/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalitybigfiveopennessleft4Inputs */



/**
* | output |
* | --- |
* | "Conservative" |
*
* @param {Personalitybigfiveopennessleft4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalitybigfiveopennessleft4 = /** @type {((inputs?: Personalitybigfiveopennessleft4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalitybigfiveopennessleft4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Conservative")
	if (locale === "es") return /** @type {LocalizedString} */ ("Conservador")
	return /** @type {LocalizedString} */ ("Консерватор")
});
export { personalitybigfiveopennessleft4 as "personalityBigFiveOpennessLeft" }